module.exports = __webpack_public_path__ + "static/ModernEra-Regular-3d146fd0f0304825bf323286954ca2fc.eot";